import { defineMessages } from 'react-intl';

export default defineMessages({
  signIn: {
    id: 'widget.account.sign-in',
    defaultMessage: 'Sign in',
  },
  signInToComplete1: {
    id: 'widget.account.sign-in-to-complete.part-1',
    defaultMessage: 'Sign in to complete',
  },
  signInToComplete2: {
    id: 'widget.account.sign-in-to-complete.part-2',
    defaultMessage: 'your purchase',
  },
  signInToWatch1: {
    id: 'widget.account.sign-in-to-watch.part-1',
    defaultMessage: 'Sign up to watch this video.',
  },
  signInToWatch2: {
    id: 'widget.account.sign-in-to-watch.part-2',
    defaultMessage: 'It\'ll only take a sec.',
  },
  signUp: {
    id: 'widget.account.sign-up',
    defaultMessage: 'Sign up',
  },
  logout: {
    id: 'widget.account.logout',
    defaultMessage: 'Log out',
  },
  forgotPassword: {
    id: 'widget.account.forgot-password',
    defaultMessage: 'Forgot Password',
  },
  myAccount: {
    id: 'widget.account.my-account',
    defaultMessage: 'My account',
  },
  email: {
    id: 'widget.account.email',
    defaultMessage: 'Email',
  },
  password: {
    id: 'widget.account.password',
    defaultMessage: 'Password',
  },
  notHaveAccount: {
    id: 'widget.account.not-have-account',
    defaultMessage: 'Don’t have an account?',
  },
  haveAccount: {
    id: 'widget.account.have-account',
    defaultMessage: 'Already have an account?',
  },
  forgotPasswordQuestion: {
    id: 'widget.account.forgot-password.question',
    defaultMessage: 'Forgot password?',
  },
  forgotPasswordMessage1: {
    id: 'widget.account.forgot-password.message1',
    defaultMessage: 'Fill in the email address you signed up with and we will email you a reset link.',
  },
  forgotPasswordMessage2: {
    id: 'widget.account.forgot-password.message2',
    defaultMessage: 'No worries, everything will be here when you return to complete you purchase.',
  },
  forgotPasswordSubmitted1: {
    id: 'widget.account.forgot-password.submitted1',
    defaultMessage: 'We’ve emailed a link to reset your password to "{email}".',
  },
  forgotPasswordSubmitted2: {
    id: 'widget.account.forgot-password.submitted2',
    defaultMessage: 'We’ll be snacking some popcorn until you are done.',
  },
  gotIt: {
    id: 'widget.account.forgot-password.got-it',
    defaultMessage: 'Got it!',
  },
  back: {
    id: 'widget.account.back',
    defaultMessage: 'Back',
  },
  backToSignIn: {
    id: 'widget.account.back-to-sign-in',
    defaultMessage: 'Back to sign in',
  },
  sendLink: {
    id: 'widget.account.send-link',
    defaultMessage: 'Send me a link',
  },
  resetPassword: {
    id: 'widget.account.reset-password',
    defaultMessage: 'Reset Password',
  },
  resetPasswordMessage: {
    id: 'widget.account.reset-password.linkText',
    defaultMessage: 'To set your new password, please enter it in both fields below.',
  },
  resetPasswordButton: {
    id: 'widget.account.reset-password.button',
    defaultMessage: 'Reset password',
  },
  enterNewPassword: {
    id: 'widget.account.reset-password.enter-new-password',
    defaultMessage: 'Enter a new password',
  },
  verifyPassword: {
    id: 'widget.account.reset-password.verify-password',
    defaultMessage: 'Verify password',
  },
  resetComplete: {
    id: 'widget.account.reset-password.complete',
    defaultMessage: 'You’ve successfully reset your password!',
  },
  continueToSite: {
    id: 'widget.account.reset-password.continue-to-site',
    defaultMessage: 'Continue to site',
  },
  readyAction: {
    id: 'widget.account.ready-action',
    defaultMessage: 'Ready for action!',
  },
  signedAs: {
    id: 'widget.account.signed-as',
    defaultMessage: 'You are signed in as:',
  },
  notYourAccount: {
    id: 'widget.account.not-your-account',
    defaultMessage: 'Not your account?',
  },
});



// WEBPACK FOOTER //
// ./src/widget/components/account/translations.js